import { countryCodeData } from "../../countryCodes";
const phonevalidator = (phoneNumber, country) => {
    const countryInfo = countryCodeData[country];

    if(!countryInfo){
        return "Invalid country code"
    }

  const expectedLengths = countryInfo.phoneNumberLength.map((length) => `\\d{${length}}`);
  const regex = new RegExp(`^\\${countryInfo?.isdCode}(${expectedLengths.join('|')})$`);

  if (!regex.test(phoneNumber)) {
    return `Number should have ${countryInfo.phoneNumberLength.join('/ ')} digits.`;
  }
  
    return null;
}

export default phonevalidator;